import type { ColumnsType } from 'antd/es/table'
import React from 'react'
import { DataType } from './interface'
import { Value } from '../../elements'
import { RowActionMenu } from '../../../components/row-action-menu'
import { CommentCell } from '../../../components/v2/comment-cell'
import { formatPhoneForDemo } from 'src/lib/demo-privacy'

const formatPhoneNumber = (phoneNumber?: string) => {
  if (!phoneNumber) {
    return <Value data={undefined} />
  }
  return formatPhoneForDemo(phoneNumber)
}

export const getColumns = (goLeader: Boolean, brandLeader: Boolean, sorter, deleteRecord) => {
  // brand, office для руководителя аксиомы и для руководителя бренда

  const Columns: ColumnsType<DataType> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 70,
      fixed: 'left'
    },
    {
      title: 'ФИО',
      dataIndex: 'name',
      key: 'name',
      width: 170,
    },
  ]
  const brand: ColumnsType<DataType> = [
  {
    title: 'Бренд',
    key: 'brand_name',
    dataIndex: 'brand_name',
    width: 70,
  }]

  const office: ColumnsType<DataType> =[
  {
    title: 'Офис',
    key: 'office_name',
    dataIndex: 'office_name',
    width: 180,
  }]
  if (goLeader) {
    Columns.push(...brand, ...office)
  }
  if (brandLeader) {
    Columns.push(...office)
  }
  Columns.push(...[
    {
      title: 'Телефон',
      width: 120,
      dataIndex: 'phone',
      key: 'phone',
      render: val => formatPhoneNumber(val)
    },
    {
      title: 'E-mail',
      width: 120,
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Авито ID',
      width: 120,
      dataIndex: 'avito_id',
      key: 'avito_id',
    },
    {
      title: 'Комментарий',
      width: 80,
      dataIndex: 'comment',
      key: 'comment',
      align: 'center' as const,
      render: (comment) => <CommentCell comment={comment} />
    },
  ])

  const ColumnAction: ColumnsType<DataType> = [
    {
      title: '',
      key: 'operation',
      className: 'no-edit',
      fixed: 'right',
      width: 50,
      align: 'center',
      render: (_, { id }) => {
        return (
          <span onClick={(e) => e.stopPropagation()}>
            <RowActionMenu id={Number(id)} deleteRecord={deleteRecord} />
          </span>
        )
      },
    }
  ]
  // собирает колонки для разных ролей
  const columns = goLeader ? Columns.concat(ColumnAction) : Columns
  // Формирует колонки и устанавливает порядок сортировки
  return columns.map(item => {
    if (item.key === sorter.sort_field)
      item.sortOrder = sorter.sort_order
    else
      delete item.sortOrder
    return item
  })
}
